import React from 'react';
import PropTypes from 'prop-types';
import styles from './ClickableCardsSection.module.less';
import CardsRow from './CardsRow';

const ClickableCardsSection = ({ ecmContent }) => {
  const { title, subtitle, cards, style = {} } = ecmContent;
  return (
    <div className={styles.card_section_container} style={style}>
      <p className={styles.card_section_title}>{title}</p>
      {subtitle && <p className={styles.card_section_subtitle}>{subtitle}</p>}
      <CardsRow row={cards} />
    </div>
  );
};

ClickableCardsSection.propTypes = { ecmContent: PropTypes.object };
ClickableCardsSection.defaultProps = {
  ecmContent: { title: '', cards: [], columns: 1 }
};

export default ClickableCardsSection;
